import { getResponsiveStyles, mergeStyles } from '../../../component-themes';
const featureListFeatureContentDescriptionBase = (tokens) => ({ size, variant, }) => mergeStyles([
    {
        display: 'inline',
        verticalAlign: 'middle',
        color: tokens.styles[`featureList-feature-content-header-description-${variant}-${size}-color`],
        fontSize: tokens.styles[`featureList-feature-content-header-description-${variant}-${size}-fontSize`],
        fontWeight: tokens.styles[`featureList-feature-content-header-description-${variant}-${size}-fontWeight`],
        fontFamily: tokens.styles[`featureList-feature-content-header-description-${variant}-${size}-fontFamily`],
        lineHeight: tokens.styles[`featureList-feature-content-header-description-${variant}-${size}-lineHeight`],
        letterSpacing: tokens.styles[`featureList-feature-content-header-description-${variant}-${size}-letterSpacing`],
    },
]);
export const featureListItemDescription = (tokens) => ({ size, variant, }) => getResponsiveStyles(size, (size) => featureListFeatureContentDescriptionBase(tokens)({ size, variant }));
